export const ARTICLE_TYPES = {
  SPONSORED: 'Sponsored Article',
  NEWS: 'News Article',
  FEATURE: 'Feature Article',
  PRODUCT_EDUCATION: 'Product/Education Article'
};

export const ARTICLE_LAYOUT_STYLES = {
  STANDARD: 'Standard',
  STANDARD_WITHOUT_IN_ARTICLE_ADS: 'Standard - Without in Article Ads',
  FEATURE: 'Feature'
};

export const ARTICLE_CATEGORIES = {
  SPONSORED_CONTENT: 'Sponsored Content',
  TOP_STORIES: 'Top Stories',
  SPONSORED_ARTICLE: 'Sponsored Article',
  PARTNER_CONTENT: 'Partner Content',
  LATEST_NEWS: 'Latest News'
};

export const SPONSORED_PILLAR = 'partner';

export const EMPTY_FILTER: ArticleFilter = {
  sector: [],
  location: [],
  contentCategory: [],
  status: [],
  pillar: []
};

export const EMPTY_EVENT_FILTER: EventFilter = {
  sector: [],
  locationFilter: [],
  category: [],
  eventType: []
};

export const ARTICLE_DATE_FORMAT = 'EEE dd MMM yy';
export const ON_DEMAND_DATE_FORMAT = 'dd MMM yy';
